import { swSettings } from "app/common/services/swSettings";

export const isHasNoWWPermissions = (country: string) =>
    country === "999" && !swSettings.allowedCountry(country, "WebAnalysis");

export const websiteWorldWideOverviewLogic = (country: string) => {
    const isWWWithoutPermissions = isHasNoWWPermissions(country);
    const apiController = isWWWithoutPermissions ? "WorldwideOverview" : "WebsiteOverview";
    return {
        isWWWithoutPermissions,
        apiController,
        // WebsiteOverview serves Total directly, the worldwide variant has a dedicated Total controller
        totalApiController: isWWWithoutPermissions ? `${apiController}Total` : apiController,
    };
};

const keywordWorldWideOverviewLogic = (country: string) => {
    return isHasNoWWPermissions(country) ? "WorldWide" : "";
};
